var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { inject, observer } from 'mobx-react';
import { Card, Col, Container, FormGroup, Input, Label, Row } from 'reactstrap';
import { Button, CheckBox } from '../../../../elements';
import { t, T } from '../../../../helpers/i18n';
import CommmissionCollaborator from '../../../Collaborators/container/CommissionCollaborator';
import CollaboratorStretchSelect from '../../../Collaborators/container/CollaboratorStretchSelect';
import { useCollaboratorForm } from '../../../../hooks/useCollaboratorForm';
import { ButtonsBar } from '../../../../Styles';
import History from '../../../../helpers/History';
import cxs from 'cxs/component';
import Theme, { mediaQueries } from '../../../../Theme';
import PropTypes from 'prop-types';
import { loading } from '../../../../elements/Loading';
// Constantes para mejorar la mantenibilidad
var CIVITRIP_CLIENT_ID = 137;
var CIVITRIP_NAME = 'Civitrip';
var CivitripClientForm = function (props) {
    var _a = props.stretches, stretches = _a === void 0 ? [] : _a, collaboratorCivitrip = props.collaboratorCivitrip, civitripClient = props.civitripClient, store = props.store, errorClient = props.errorClient;
    console.log('stretches.length', stretches.length);
    console.log('collaboratorCivitrip', collaboratorCivitrip);
    // Estados locales (removemos clientActivated ya que no lo necesitamos)
    var _b = useState(), client = _b[0], setClient = _b[1];
    var _c = useState(false), isAgency = _c[0], setIsAgency = _c[1];
    var _d = useState(true), provider = _d[0], setProvider = _d[1];
    var _e = useState([]), okMessages = _e[0], setOKMessages = _e[1];
    var _f = useState([]), errorMessages = _f[0], setErrorMessages = _f[1];
    var _g = useState(false), showFormCard = _g[0], setShowFormCard = _g[1];
    var _h = useState(false), isLoading = _h[0], setIsLoading = _h[1];
    // Memoización para optimizar renders
    var agencySelected = useMemo(function () { var _a; return (_a = civitripClient === null || civitripClient === void 0 ? void 0 : civitripClient.agencies) === null || _a === void 0 ? void 0 : _a[0]; }, [civitripClient]);
    var hasParent = useMemo(function () {
        return (History.location.pathname.match(/\//g) || []).length >= 2;
    }, []);
    var _j = useCollaboratorForm(collaboratorCivitrip, store, collaboratorCivitrip === null || collaboratorCivitrip === void 0 ? void 0 : collaboratorCivitrip.id), handleSubmit = _j.handleSubmit, handleCancel = _j.handleCancel, selectedStretches = _j.selectedStretches, handleChange = _j.handleChange;
    // Función para limpiar mensajes
    var clearMessages = useCallback(function () {
        setOKMessages([]);
        setErrorMessages([]);
    }, []);
    // Función para agregar Civitrip como colaborador (simplificada)
    var addCivitripCollaborator = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!store)
                        return [2 /*return*/];
                    setIsLoading(true);
                    clearMessages();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, store.collaboratorStore.create({
                            client_id: CIVITRIP_CLIENT_ID
                        })];
                case 2:
                    _a.sent();
                    setOKMessages(['Civitrip agregado como colaborador exitosamente']);
                    props.store.collaboratorStore.read();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error('Error añadiendo a Civitrip como colaborador', error_1);
                    setErrorMessages(['Error al agregar Civitrip como colaborador']);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [store, clearMessages]);
    // Función para activar cliente en Civitrip (simplificada)
    var activateCivitripClient = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!store)
                        return [2 /*return*/];
                    setIsLoading(true);
                    clearMessages(); // Limpiar mensajes anteriores
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, store.civitripClientsStore.create({
                            isAgency: isAgency,
                            isProvider: provider
                        })];
                case 2:
                    _a.sent();
                    setOKMessages(['Cliente activado exitosamente en Civitrip']);
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    console.error('Error al activar cliente:', error_2);
                    setErrorMessages(['Error al activar el cliente en Civitrip']);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [store, isAgency, provider, clearMessages]);
    // Función para aplicar datos de cuenta
    var handleClickAccountData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_3;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!((_b = (_a = store === null || store === void 0 ? void 0 : store.users) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.client))
                        return [2 /*return*/];
                    console.log('Aplicando valores de Ticando a Civitrip');
                    setIsLoading(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, store.civitripClientsStore.update(store.users.user.client, {
                            isProvider: true,
                            transferTicandoValues: true
                        })];
                case 2:
                    _c.sent();
                    setOKMessages(['Datos de cuenta aplicados correctamente']);
                    return [3 /*break*/, 5];
                case 3:
                    error_3 = _c.sent();
                    console.error('Error al aplicar datos:', error_3);
                    setErrorMessages(['Error al aplicar los datos de cuenta']);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [store]);
    // Handlers para Paylands
    var handleCardSaved = useCallback(function (data) {
        console.log('¡Tarjeta guardada con éxito!: ', data);
        setOKMessages(['¡Tarjeta guardada con éxito!']);
        setShowFormCard(false);
    }, []);
    var handlePaylandsError = useCallback(function (error) {
        console.error('Hubo un error con Paylands: ', error);
        setErrorMessages(['Hubo un error al procesar la tarjeta, inténtelo más tarde']);
    }, []);
    var handleTokenFetchError = useCallback(function (error) {
        console.error('Error al obtener el token: ', error);
        setErrorMessages(['Error al obtener el token de autenticación']);
    }, []);
    // Función para enviar rutas a Civitrip
    var sendStretchesToCivitrip = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var stretchesSelected, result, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!store)
                        return [2 /*return*/];
                    stretchesSelected = getStretchesSelected(stretches, selectedStretches);
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, store.civitripClientsStore.sendStretchesToCivitrip(stretchesSelected)];
                case 2:
                    result = _a.sent();
                    setOKMessages(result.okStretches);
                    setErrorMessages(result.errorStretches);
                    return [3 /*break*/, 5];
                case 3:
                    error_4 = _a.sent();
                    console.error('Error enviando rutas:', error_4);
                    setErrorMessages(['Error al enviar las rutas a Civitrip']);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [store, stretches, selectedStretches]);
    // Efecto para cargar datos iniciales si no están en el store
    useEffect(function () {
        if (!store)
            return;
        var loadInitialData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var clientName, error_5;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 7, , 8]);
                        clientName = (_b = (_a = store.users) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.client;
                        if (!(!civitripClient && clientName)) return [3 /*break*/, 2];
                        return [4 /*yield*/, store.civitripClientsStore.read(clientName)];
                    case 1:
                        _c.sent();
                        _c.label = 2;
                    case 2:
                        if (!!collaboratorCivitrip) return [3 /*break*/, 4];
                        return [4 /*yield*/, store.collaboratorStore.read()];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4:
                        if (!!stretches.length) return [3 /*break*/, 6];
                        return [4 /*yield*/, store.stretches.read()];
                    case 5:
                        _c.sent();
                        _c.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        error_5 = _c.sent();
                        console.error('Error cargando datos iniciales:', error_5);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        loadInitialData();
    }, [store, civitripClient, collaboratorCivitrip, stretches.length]);
    // Efecto para cargar datos del cliente (simplificado)
    useEffect(function () {
        if (!store || client)
            return;
        store.acountStore.read()
            .then(function (result) {
            setClient(result);
        })
            .catch(function (error) {
            console.error('Error cargando cliente:', error);
            setErrorMessages(['Error al cargar los datos del cliente']);
        });
    }, [store, client]);
    useEffect(function () {
        console.log('Colaborador Civitrip actualizado: ', collaboratorCivitrip);
    }, [collaboratorCivitrip]);
    // Renderizado condicional para errores (simplificado)
    if ((errorClient === null || errorClient === void 0 ? void 0 : errorClient.message) === 'clientNotFound') {
        if (!collaboratorCivitrip) {
            return (React.createElement(Container, null,
                React.createElement(Card, { className: "m-3 p-3" },
                    React.createElement("h3", null, "Civitrip no es colaborador"),
                    React.createElement("p", null, "Pulsa a\u00F1adir para agregarlo como colaborador"),
                    React.createElement(Button, { onClick: addCivitripCollaborator, disabled: isLoading }, isLoading ? 'Agregando...' : T('add'))),
                React.createElement(MessageDisplay, { okMessages: okMessages, errorMessages: errorMessages })));
        }
        return (React.createElement(Container, null,
            React.createElement(Card, { className: "m-3 p-3" },
                React.createElement("h3", null, "No est\u00E1s en Civitrip"),
                React.createElement("p", null, "Configura tu tipo de cuenta y act\u00EDvala"),
                React.createElement(FormGroup, null,
                    React.createElement(CheckBox, { checked: isAgency, label: T('agency'), onChange: setIsAgency })),
                React.createElement(FormGroup, null,
                    React.createElement(CheckBox, { checked: provider, label: T('provider'), onChange: setProvider })),
                React.createElement(Button, { onClick: activateCivitripClient, disabled: isLoading }, isLoading ? 'Activando...' : T('activate'))),
            React.createElement(MessageDisplay, { okMessages: okMessages, errorMessages: errorMessages })));
    }
    if (!civitripClient) {
        return null;
    }
    return (React.createElement(Container, null,
        React.createElement(Card, { className: "m-3 p-3" },
            React.createElement("h4", null, "Informaci\u00F3n del Cliente"),
            React.createElement(Row, { className: "align-items-center" },
                React.createElement(Col, { xl: 4, md: 6, sm: 12 },
                    React.createElement(FormGroup, null,
                        React.createElement(Label, { for: "name" }, T('name')),
                        React.createElement(Input, { value: civitripClient.name || '', id: "name", disabled: true }))),
                React.createElement(Col, { xl: 4, md: 6, sm: 12 },
                    React.createElement(FormGroup, null,
                        React.createElement(Label, { for: "email" }, T('email')),
                        React.createElement(Input, { value: civitripClient.email || '', type: "email", id: "email", disabled: true }))),
                React.createElement(Col, { xl: 4, md: 6, sm: 12 },
                    React.createElement(FormGroup, null,
                        React.createElement(Label, { for: "taxId" }, T('taxId')),
                        React.createElement(Input, { value: civitripClient.taxId || '', id: "taxId", disabled: true })))),
            React.createElement(Button, { style: __assign({}, Theme.border), onClick: handleClickAccountData, disabled: isLoading }, isLoading ? 'Aplicando...' : 'Aplicar datos de cuenta Ticando a Civitrip')),
        collaboratorCivitrip && stretches.length > 0 && (React.createElement(CommmissionCollaborator, { collaborator: collaboratorCivitrip })),
        civitripClient && !showFormCard && (React.createElement(PaymentCardsSection, { agencies: civitripClient.agencies, onAddCard: function (agency) {
                store.paymentGawewaysStores.addPaymentToken({
                    account: store.acountStore.data,
                    agency: agency
                });
                // setShowFormCard(true)
            } })),
        collaboratorCivitrip && (stretches === null || stretches === void 0 ? void 0 : stretches.length) > 0 && (React.createElement(CollaboratorStretchSelect, { stretches: stretches, selectedStretches: selectedStretches, onChange: handleChange },
            React.createElement(Button, { onClick: sendStretchesToCivitrip, disabled: isLoading }, isLoading ? 'Enviando...' : T('sendToCivitrip')))),
        !collaboratorCivitrip && (React.createElement(Card, { className: "m-3 p-3" },
            React.createElement(Button, { onClick: addCivitripCollaborator, disabled: isLoading }, isLoading ? 'Agregando...' : 'Añadir a Civitrip como colaborador'))),
        React.createElement(MessageDisplay, { okMessages: okMessages, errorMessages: errorMessages }),
        React.createElement(ButtonsBar, null,
            hasParent && (React.createElement(StyledButton, { onClick: handleCancel, disabled: isLoading }, t('cancel'))),
            React.createElement(StyledButton, { primary: true, loading: isLoading, onClick: handleSubmit }, t('save')))));
};
// Componente para mostrar mensajes
var MessageDisplay = function (_a) {
    var okMessages = _a.okMessages, errorMessages = _a.errorMessages;
    return (React.createElement(React.Fragment, null,
        okMessages.length > 0 && (React.createElement(Card, { className: "m-3 p-3 border-success" },
            React.createElement("h4", { style: { color: 'green' } }, T('correctly')),
            okMessages.map(function (message, index) { return (React.createElement("p", { key: index, style: { color: 'green' } }, message)); }))),
        errorMessages.length > 0 && (React.createElement(Card, { className: "m-3 p-3 border-danger" },
            React.createElement("h4", { style: { color: 'red' } }, T('error')),
            errorMessages.map(function (message, index) { return (React.createElement("p", { key: index, style: { color: 'red' } }, message)); })))));
};
// Componente para tarjetas de pago
var PaymentCardsSection = function (_a) {
    var agencies = _a.agencies, onAddCard = _a.onAddCard;
    return (React.createElement(React.Fragment, null, agencies && agencies.map(function (agency) {
        var pcEnabled = agency.paymentCards && agency.paymentCards.filter(function (pc) { return !pc.disabled_at; }) || [];
        return (React.createElement(Card, { key: agency.id, className: "m-3 p-3" },
            React.createElement(Row, { className: "align-items-center" },
                React.createElement(Col, { xl: 8, md: 6, sm: 12 },
                    React.createElement("h5", null, agency.name),
                    React.createElement("h6", null, T('paymentCards')),
                    pcEnabled.map(function (paymentCard) { return (React.createElement("div", { key: paymentCard.id, className: "mb-2" },
                        React.createElement("strong", null, paymentCard.alias))); })),
                React.createElement(Col, { xl: 4, md: 6, sm: 12 },
                    React.createElement(Button, { style: __assign({}, Theme.border), onClick: function () { return onAddCard(agency); } }, T('addCard'))))));
    })));
};
// Wrapper de datos simplificado - ahora los datos vienen directamente del store observable
export default inject('store')(loading(function (props) {
    var name = props.store.users.user.client;
    return [
        props.store.civitripClientsStore.read(name),
        props.store.collaboratorStore.read(),
        props.store.stretches.read()
    ];
})(observer(function (props) {
    var _a;
    // Los datos ahora vienen directamente del store y son reactivos
    var civitripClient = props.store.civitripClientsStore.civitripClient;
    var collaboratorCivitrip = (_a = props.store.collaboratorStore.collaborators) === null || _a === void 0 ? void 0 : _a.find(function (c) { return c.name === CIVITRIP_NAME; });
    var stretches = props.stretches || props.store.stretches.data || [];
    var errorClient = props.store.civitripClientsStore.error ? new Error(props.store.civitripClientsStore.error) : null;
    return (React.createElement(CivitripClientForm, __assign({}, props, { civitripClient: civitripClient, collaboratorCivitrip: collaboratorCivitrip, stretches: stretches, errorClient: errorClient })));
})));
var StyledButton = cxs(Button)(function (_a) {
    var _b;
    var isDisabled = _a.isDisabled;
    return (_b = {
            color: isDisabled ? Theme.color.primary : 'inherit'
        },
        _b[mediaQueries.desktop] = {
            padding: Theme.size.space[2]
        },
        _b);
});
StyledButton.propTypes = {
    isDisabled: PropTypes.bool
};
var getStretchesSelected = function (stretches, selectedStretches) {
    var stretchesSelected = stretches.filter(function (stretch) {
        return selectedStretches.includes(String(stretch.id));
    });
    console.log('stretchesSelected: ', stretchesSelected);
    return stretchesSelected;
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Acount/Civitrip/containers/CivitripClientForm.tsx
// module id = 1571
// module chunks = 0